export enum JoinpointState {
    Before = 'Before',
    Pointcut = 'Pointcut',
    After = 'After',
    AfterReturning = 'AfterReturning',
    AfterThrowing = 'AfterThrowing'
}
